// extracted by mini-css-extract-plugin
export default {"userImage":"usercard_userImage__eX00i","card":"usercard_card__HYbTi","cardName":"usercard_cardName__AwStG","cardInfo":"usercard_cardInfo__xf9nG","link":"usercard_link__FobV2"};